/**
 * Global frontend event bus
 */
export default class EventBus {
  constructor() {
    this._events = {}
    this._callbackId = 0
  }

  /**
   * @param {String} name
   * @param {Function} callback
   * @param {Boolean} once
   */
  _addEvent(name, callback, once) {
    if (!this._events[name]) {
      this._events[name] = {}
    }

    const id = (once ? 'd' : '') + this._callbackId++
    this._events[name][id] = callback

    const unSubscribe = () => {
      delete this._events[name][id]

      if (Object.keys(this._events[name]).length === 0) {
        delete this._events[name]
      }
    }

    return { unSubscribe }
  }

  /**
   * @param {string} eventName
   * @param {function} callback
   */
  on(eventName, callback) {
    return this._addEvent(eventName, callback)
  }

  /**
   * @param {string} eventName
   * @param {function} callback
   */
  once(eventName, callback) {
    return this._addEvent(eventName, callback, true)
  }

  /**
   * @param {string} eventName
   * @param {object} args
   */
  emit(eventName, ...args) {
    const callbackObject = this._events[eventName]
    if (!callbackObject) return console.warn(eventName + ' not found!')

    for (let id in callbackObject) {
      callbackObject[id](...args)
      if (id[0] === 'd') delete callbackObject[id]
    }
  }

  /**
   * @param {string} eventName
   */
  clear(eventName) {
    if (!eventName) {
      this._events = {}
      return
    }

    delete this._events[eventName]
  }
}